/**
 * Effective Adult/Child/Infant classification — the single place that collapses the
 * optional hotel `hotelClass` onto a 3-way label, with the binary fallback for plain /
 * bookmarked URLs (no classification). This is the COUNT / LABEL bridge; the form layer
 * uses the 4-way `deriveVariant` (travelerVariant.ts) instead, which additionally splits
 * out `under18adult`.
 *
 * Two input shapes exist and are not interchangeable:
 *   - wire / participant objects carry a binary `type` ('adult' | 'child');
 *   - the store `Passenger` carries `isAdult` (no `type`).
 *
 * See claude/specs/ChildVsInfant.
 */

import type { Passenger } from '@/types/checkout';

export type HotelClass = 'adult' | 'child' | 'infant';

/** Wire / participant shape: prefer the hotel class, else the binary `type`. */
export function effectiveHotelClass(p: { type: string; hotelClass?: HotelClass }): HotelClass {
  return p.hotelClass ?? (p.type === 'child' ? 'child' : 'adult');
}

/** Store `Passenger` shape: prefer the hotel class, else the binary `isAdult` flag. */
export function classifyPassenger(p: Pick<Passenger, 'hotelClass' | 'isAdult'>): HotelClass {
  return p.hotelClass ?? (p.isAdult ? 'adult' : 'child');
}
